import { defineNoaIntegrationClient } from '@/plugins/request';

export const useUserClient = defineNoaIntegrationClient({
  options: ({ baseURL }) => ({
    baseURL: `${baseURL}/api/fc/v1/users`,
  }),
});

export const useNoaIntegrationClient = defineNoaIntegrationClient({
  options: ({ baseURL }) => ({
    baseURL: `${baseURL}/api/fc/v1`,
  }),
});

export const useNoaIntegrationAuthClient = defineNoaIntegrationClient({
  options: ({ baseURL }) => ({
    baseURL: `${baseURL}/api/v1/sso`,
  }),
});
